module.exports = __webpack_public_path__ + "static/record-4be6de5c8a68ede2f09a60a201a97e6e.png";